
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { getStorage } from "@/common/utils";
@Component({
  name: "Aside",
  components: {},
})
export default class Aside extends Vue {
  activeRouter: string = this.$route.path;
  @Action("account/getAuthernData") private getAuthern: any;
  @Getter("role") private role!: string;
  @Getter("roleSave") private isAuthern!: string;
  company: any = "";
  created() {
    this.getAuthern();
    const data = getStorage("basic");
    if (data) {
      const { nickName } = data;
      this.company = nickName;
    }
  }
  toHome() {
    this.$router.push({ path: "/pcm/homePage" });
  }
  handleOpen() {}
  handleClose() {}
  handleSelect(key: any, keyPath: any) {
    if (this.$route.path === key) {
      // location.reload();
      return;
    }
    if (key.includes("/user/home")) {
      this.$router.push({ name: "UserHome" });
    } else {
      this.$router.push({ path: key });
    }
  }
  @Watch(`$route`)
  handleRoutechange({ path }: any, from: any) {
    // this.path = path;
    // if(path === '/company/pro/detail') {
    //   this.activeRouter = `/${this.role}/pro`;
    // } else {
    //   }
    this.activeRouter = this.$route.path;
  }
}
